import { DEFAULT_LANGUAGE, LANGUAGES, ServiceId, SERVICE_TYPES, ServiceType } from '@/data'

export const getMergedLanguageQueryString = (
  objectSuffix: string,
  fieldsArray: (string | { name: string; fields: string; dereference?: boolean; isArray?: boolean })[],
) => {
  let defaultQueryString = ''
  let localizedQueryString = ''

  fieldsArray.forEach(item => {
    if (typeof item === 'string') {
      defaultQueryString += `${item},`
      localizedQueryString += `defined(${item}) => {"${item}": ${item}},`
    } else if (typeof item === 'object' && item !== null) {
      const arrString = item.isArray ? '[]' : ''
      defaultQueryString += `${item?.dereference ? `${item.name} ${arrString}->` : `${item.name}${arrString}`} {${
        item.fields
      }},`
      localizedQueryString += `
      defined(${item.name}) => {
        ${item?.dereference ? `'${item.name}': ${item.name} ${arrString}->` : `'${item.name}${arrString}': `} {
          ${item.fields}
        }
      },
      `
    }
  })

  const query = `
    ${Object.values(LANGUAGES)
      .map(language => {
        if (language === DEFAULT_LANGUAGE) {
          return `
            $language == "${DEFAULT_LANGUAGE}" => {
              ...(${DEFAULT_LANGUAGE}${objectSuffix}) {
                ${defaultQueryString}
              }
            }
          `
        } else {
          return `
            $language == "${language}" => {
              ...(${DEFAULT_LANGUAGE}${objectSuffix}) {
                ${defaultQueryString}
              },
              ...(${language}${objectSuffix}) {
                ${localizedQueryString}
              }
            }
          `
        }
      })
      .join(',')}
  `

  return query
}

export const getDomainNameFromUrlString = (urlString: string) => {
  const url = new URL(urlString)
  const domain = url.hostname
  return domain
}

export const getServiceNameKeyFromUrl = (url: string): ServiceId | undefined => {
  const lowerUrl = url.toLowerCase()
  if (lowerUrl.includes('order.store')) return 'uberEats'
  const servicePatterns: Record<string, ServiceId> = {
    'yelp.c': 'yelp',
    ubereats: 'uberEats',
    'order.store': 'uberEats',
    trycaviar: 'caviar',
    doordash: 'doorDash',
    grubhub: 'grubHub',
    postmates: 'postmates',
    'goldbelly.com': 'goldbelly',
  }
  return Object.entries(servicePatterns).find(([pattern]) => lowerUrl.includes(pattern))?.[1]
}

export const getServiceLinksByService = (serviceLinks: SanityLocationServiceLinkType[]) => {
  const items: { [key in ServiceType]: { url: string; serviceName?: ServiceId }[] } = {
    [SERVICE_TYPES.GENERAL_RESERVATION]: [],
    [SERVICE_TYPES.DINING_ROOM]: [],
    [SERVICE_TYPES.BAR_COUNTER]: [],
    [SERVICE_TYPES.CATERING]: [],
    [SERVICE_TYPES.DELIVERY]: [],
    [SERVICE_TYPES.PICKUP]: [],
    [SERVICE_TYPES.RESERVATIONS]: [],
  }

  if (serviceLinks?.length) {
    serviceLinks.forEach(item => {
      if (items[item.serviceType]) {
        const serviceName = getServiceNameKeyFromUrl(item.url)
        items[item.serviceType].push({ url: item.url, serviceName })
      }
    })
  }

  return items
}
